import { AwardIcon } from 'lucide-react'
import Image from 'next/image'
import { SectionHeader } from '../SectionHeader'
import type { ValueSectionData } from '@/data/solutions/types'

type ValueSectionProps = ValueSectionData

export const ValueSection = ({ heading, values }: ValueSectionProps) => {
  return (
    <div className="space-y-8">
      <SectionHeader
        label="Value"
        icon={<AwardIcon className="h-4 w-4" />}
        heading={heading}
        color="inc-primary-10"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8">
        {values.map(item => (
          <div
            key={item.title}
            className="flex flex-col justify-between text-center gap-10"
          >
            <div className="space-y-2 px-2">
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <p className="text-sm md:text-base text-[#374151] leading-6">
                {item.description}
              </p>
            </div>
            <div className="w-full aspect-4/3 relative overflow-hidden rounded-3xl">
              <Image
                src={item.image}
                alt={item.title}
                fill
                className="object-cover"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
